import React, { useEffect, useRef, useState } from 'react';
import AnimateSlider from 'jd-library/AnimateSlider';
import SliderHeader from 'jd-library/SliderHeader';
import Button from 'jd-library/Button';
import CheckboxList from './CheckboxList';
import style from './mobile-filter.scss';
import filterStyle from '../../common/Filter/mobile-filter.scss';
import listingStyle from '../../pages/listing/listing.scss';
import MobileFilterRipple from './MobileFilterRipple';
import CSSTransform from '../transition/Animation';
import { connect } from 'react-redux';
import { updateDeletionPending, updateGenericDeletionPending } from '../../actions/products';

function FilterKeyList(props) {
    let { activeIndex, items } = props;

    return (
        <div className={style['left-list']}>
            {items.map((cur, index) => {

                const activeClass = (index == activeIndex) ? 'active' : '';
                const border = (index == activeIndex + 1) ? 'border-tr-radius' : ((index == activeIndex - 1) ? 'border-br-radius' : '');

                return (
                    <MobileFilterRipple
                        className={style['width-100'] + ' ' + style['cursor-pointer']}
                        clickHandler={() => props.openFilterCB(index)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') props.openFilterCB(index); }}
                    >
                        <div
                            className={`${style['left-list-element-holder']} ${style[activeClass]} ${border}`}
                            key={index}>
                            <div
                                className={`${style['filter-key']}`}
                            >
                                {cur.label.replace('/',' / ')}
                                {props.appliedFilter[cur.serviceKey] && (
                                    <i className={`icon icon-circle ${style['red-dot']}`}></i>
                                )}
                            </div>
                        </div>
                    </MobileFilterRipple>
                )
            })}
            <div
                className={`${(activeIndex + 1) == items.length ? 'border-tr-radius' : ''} ${style['left-empty-space']}`}>
            </div>
        </div>
    )
}

function SubList(props) {
    return (
        <div className={`${props.animate} ${style['right-list']}`}>
            {props.type == 'checkbox' && (
                <CheckboxList
                    {...props}
                    className={`${style['checkbox-filter']}`}
                    onChangeCB={(key, val) => props.onUpdate(key, val)}
                    labelPosition={'before'}
                />
            )}
        </div>
    )
}

const MobileFilter = (props) => {

    const filterSliderRef = useRef();
    const searchRef = useRef();
    const [state, setState] = useState({
        appliedFilter: {},
        rightIcon: props.sliderRightIcon,
        leftIcon: props.sliderLeftIcon,
        showLoader: false,
        headerClass: 'filter-header'
    })

    useEffect(() => {
        intializeFilter();
        switchFilter(0)
    }, [props.filterList])

    useEffect(() => {
        toggle(props.isFilterOpen)
        return () => {
            toggle(false)
        }
    }, [props.isFilterOpen])

    useEffect(() => {
        if (props.isClearFilter) {
            clearFilter()
        }
    }, [props.isClearFilter])

    useEffect(() => {
        props.isMobile ? toggleRightIcon() : toggleLeftIcon();
    }, [state.appliedFilter])

    const intializeFilter = () => {
        let filterApplied = {};
        props.filterList.map((cur) => {
            if (cur.type == 'checkbox') {
                let valArr = [];
                cur.subMenu.map((value) => (value.isChecked && valArr.push(value.value)));
                if (valArr.length)
                    filterApplied[cur.serviceKey] = valArr;
            }
        });
        setState(prv => ({ ...prv, appliedFilter: filterApplied }));
    }

    const resetFilter = () => {
        props.filterList.map((cur) => {
            if (cur.type == 'checkbox') {
                cur.subMenu.map((value) => (value.isChecked = false));
            }
        });
    }

    const applyFilter = (key, val) => {
        let data = state.appliedFilter;
        if (!val)
            delete data[key];
        else
            data[key] = val;
        setState((prv) => ({ ...prv, appliedFilter: data }));
        state.activeFilter.onChange && state.activeFilter.onChange(data);
        props.isMobile ? toggleRightIcon() : toggleLeftIcon();
    }

    const switchFilter = (index) => {
        let animateClass = '';
        if (index != state.activeFilterIndex) {
            animateClass = 'switch-progress';
            setTimeout(() => {
                setState((prv) => ({
                    ...prv, rightClass: ''
                }))
            }, 180)
        }
        setState((prv) => ({
            ...prv,
            activeFilter: props.filterList[index],
            activeFilterIndex: index,
            rightClass: animateClass
        }));
        searchRef.current && searchRef.current.scrollIntoView();
        props.onFilterChange && props.onFilterChange(state.appliedFilter, index);
    }

    const clearFilter = () => {
        resetFilter();
        setState((prv) => ({ ...prv, appliedFilter: {} }));
        setTimeout(() => { props.isMobile ? toggleRightIcon(true) : toggleLeftIcon(true) }, 0);
    }

    const toggleRightIcon = (isClear = false) => {
        const hideRightIconWhenEmpty = props.deviceData.isMobile ? true : false;
        if (hideRightIconWhenEmpty) {
            let rightIconAry = []
            if (Object.keys(state.appliedFilter).length && !isClear) {
                rightIconAry = props.sliderRightIcon
            }
            setState((prv) => ({ ...prv, rightIcon: rightIconAry }));
        }
    }

    const toggleLeftIcon = (isClear = false) => {
        const hideLeftIconWhenEmpty = !props.deviceData.isMobile ? true : false;
        if (hideLeftIconWhenEmpty) {
            let leftIconAry = []
            if (Object.keys(state.appliedFilter).length && !isClear) {
                leftIconAry = props.sliderLeftIcon
            }
            setState((prv) => ({ ...prv, leftIcon: leftIconAry }));
        }
    }

    const submit = () => {
        if (Object.keys(state.appliedFilter).length) {
            props.updateDeletionPending({ deletionPendingList: [] });
            props.updateGenericDeletionPending({ genericDeletionList: [] });
        }
        props.onSubmit && props.onSubmit(state.appliedFilter);
        toggleLoader(true)
    }

    const toggle = (flag) => {
        intializeFilter();
        switchFilter(0);
        props.isMobile ? toggleRightIcon() : toggleLeftIcon();
        toggleLoader(false);
        filterSliderRef.current.toggle(flag);
    }

    const toggleLoader = (flag) => {
        setState((prv) => ({ ...prv, showLoader: flag }));
    }

    const { headerClass, activeFilterIndex, activeFilter, rightIcon, leftIcon, rightClass } = state;
    const { isMultiSelect, isMobile } = props;

    return (
        <AnimateSlider
            ref={filterSliderRef}
            width={isMobile ? '100%' : '320px'}
            slideDirection={isMobile ? 'bottom' : "right"}
            className={`${listingStyle['header-filter']} ${props.session.hasGlassFooter ? listingStyle['ubl-footer'] : ''}`}
        >
            <SliderHeader
                className={style[headerClass]}
                heading={"Filter"}
                leftIconArray={leftIcon} //remove this when library is live
                leftIcons={leftIcon}
                rightIconArray={rightIcon} ////remove this when library is live
                rightIcons={rightIcon}
                headingClass={filterStyle['filter-heading']}
                headingIconClass={style['header-class']}
                variant={'secondary'}
                hasBorder={true}
            />
            <div className={style['filter-holder']}>
                <CSSTransform>
                    <>
                        <FilterKeyList
                            items={props.filterList}
                            activeIndex={activeFilterIndex}
                            openFilterCB={(index) => switchFilter(index)}
                            appliedFilter={state.appliedFilter}
                        />
                        <SubList
                            {...activeFilter}
                            searchRef={searchRef}
                            onUpdate={(key, val) => applyFilter(key, val)}
                            children={props.children}
                            animate={rightClass}
                            isMultiSelect={isMultiSelect && activeFilter?.label == 'Brand'}  //for brand only
                        />
                    </>
                </CSSTransform>
                <div className={`${style['filter-footer-btn']} ${props.session.hasGlassFooter ? style['ubl-btn']: ''}`}>
                    <Button
                        size="lg"
                        className={style['footer-btn']}
                        clickHandler={submit}
                        showLoader={state.showLoader}
                        raised
                    >
                        Apply
                    </Button>
                </div>
            </div>
        </AnimateSlider>
    )
}

const mapStateToProps = (state, props) => {
    return {
        ...props,
        isMobile: state.library.deviceData.isMobile,
        deviceData: state.deviceData,
        session: state.session
    }
}

export default connect(mapStateToProps, {
    updateDeletionPending,
    updateGenericDeletionPending
}, null, { forwardRef: true })(MobileFilter);